import { RoutePath } from '../../enums/RoutePath';

export const earlyWrapPaths = [
  RoutePath.ScreensEstimatesInUse,
  RoutePath.ScreensLocationLanding,
  RoutePath.ScreensLocationInUse,
  RoutePath.ScreensUnderwriterInUse,
  RoutePath.ScreensUnderwriterLanding,
];
